import { Component, Input } from '@angular/core';
import { MediaPlayerService } from '@core/service/media-player/media-player.service';
import { MediaPlayerButtonComponent } from '../media-player-button/media-player-button.component';
import { ImportALlModule } from '@shared/imports';
import { ChantMediaModel } from '@core/models/ce/chant-media-model';

@Component({
  selector: 'app-media-player-button-menu-group',
  standalone: true,
  imports: [
      ImportALlModule,
      MediaPlayerButtonComponent
  ],
  templateUrl: './media-player-button-menu-group.component.html',
  styleUrl: './media-player-button-menu-group.component.scss'
})
export class MediaPlayerButtonMenuGroupComponent {

  @Input() row!: any;
  @Input() faIcon: string='';
  @Input() currentChantDeperanceList: any[]=[];

  constructor(public mediaPlayerService: MediaPlayerService){
  }

    getDefaultMedia(row: any): ChantMediaModel | undefined {
      return row?.chantMediaAudioMerge?.find((x: any) => x.isDefault === true);
    }

    trackByFn(index: number, item: any): any {
      return item.id ?? index; // Si les objets ont un ID, Angular les suit mieux.
    }

}
